// extracted by mini-css-extract-plugin
export default {"headline":"index_headline_cR2vV","tit_tag":"index_tit_tag_g5Vhs","tit_time":"index_tit_time_O6cgn","time":"index_time_6wcO8","num":"index_num_amHkG"};